import { styled } from "../stitches.config";
export const Content = styled("div", {
  width: "100%",
  position: "relative",
  display: "flex",
  "@bp1": {
    flexDirection: "column",
  },
});
